import { AxiosClient } from './AxiosClient';
import {
    CLIENT_ID,
    CLIENT_SECRET,
    LOGIN,
    REGISTER,
    VEHICLES,
    VEHICLE_TYPE,
    VEHICLE_MAKE,
    PROFILE,
    LICENSE,
    USER,
    PAYMNENT_CARD,
    SUBSCRIPTION,
    DOCUMENTS,
    // SOLUTION_FOR_BUSINESS,
    DOWNLOAD_INVOICE,
    DOWNLOAD_CONTRACT,
    CONTACT_US,
    FEEDBACK,
    EMPLOYEE_INFO,
    ID_CARD,
    VERIFYING,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
    ENQUIRY,
    DECLARATION,
    MANUAL_PAY,
    LOANS,
    RELATIONSHIP,
    UPDATE_LIVING_EXPENSE,
    EMAIL_REDIRECT_LINK,
    CANCEL_SUBSCRIPTION,
    PASSWORD_RESET_REDIRECT_LINK,
    CHANGE_PASSWORD,
} from './EndPoints';
const RESPONSE_SUCCESS = 200;
const CREATE_SUCCESS = 201;

const login = (data) => {
    const request = {
        email: data.email,
        password: data.password,
        client_id: CLIENT_ID,
        client_secret: CLIENT_SECRET,
    };
    return new Promise((resolve, reject) => {
        AxiosClient()
            .post(LOGIN, request)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    reject('Login Failed');
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Connection Failed');
                }
            });
    });
};

const signUp = (data) => {
    const request = {
        email: data.email,
        password: data.password,
        password_confirmation: data.password,
        redirect: EMAIL_REDIRECT_LINK,
    };
    return new Promise((resolve, reject) => {
        AxiosClient()
            .post(REGISTER, request)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Server error!');
                }
            });
    });
};

const getVehicles = (data) => {
    const { token, page } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(VEHICLES, {
                params: { include: 'branch,type,model,images,rate', page: page },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
const searchVehicles = (data) => {
    const { token, params } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(VEHICLES, {
                params,
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getVehicleType = () => {
    return new Promise((resolve, reject) => {
        AxiosClient('')
            .get(VEHICLE_TYPE)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve({ vehicle_type: response.data });
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
const getVehicleMake = () => {
    // const { token } = data;
    return new Promise((resolve, reject) => {
        AxiosClient('')
            .get(VEHICLE_MAKE, {
                params: { include: 'models' },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve({ vehicle_make: response.data });
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};
const getVehiclesDetail = (data) => {
    const { token, vehicle_id } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(`${VEHICLES}/${vehicle_id}`, {
                params: { include: 'branch,type,model,images,rate' },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve({ vehicle_detail: response.data.data });
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const calculateVehiclesPrice = (data) => {
    const { token, vehicle_id, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(`${VEHICLES}/${vehicle_id}/calculate_pricing`, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const createProfile = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(PROFILE, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS || response.status === CREATE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Connection Failed');
                }
            });
    });
};

const updateProfile = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(PROFILE, request, {
                headers: {
                    accept: 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS || response.status === CREATE_SUCCESS) {
                    resolve(response?.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Connection Failed');
                }
            });
    });
};

const createLicese = (data) => {
    const { token, request } = data;

    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(LICENSE, request, {
                headers: {
                    accept: 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS || response.status === CREATE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Connection Failed');
                }
            });
    });
};

const updateLicese = (data) => {
    const { token, request } = data;

    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(LICENSE, request, {
                headers: {
                    accept: 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Connection Failed');
                }
            });
    });
};

const getUser = (data) => {
    const { token } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(USER, {
                params: {
                    include:
                        'profile,documents,license,payments,identity-card,employee-info,statement,relationships,living-expense,loans',
                },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const createPaymentMethod = (data) => {
    const { token, session_id } = data;
    const request = { session_id: session_id };
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(PAYMNENT_CARD, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS || response.status === CREATE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getPaymentMethod = (data) => {
    const { token } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(PAYMNENT_CARD)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve({ cards: response.data.data });
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const makeDefaultCard = (data) => {
    const { token, id } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .put(`${PAYMNENT_CARD}/${id}`, { is_primary: true })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const deleteCard = (data) => {
    const { token, id } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .delete(`${PAYMNENT_CARD}/${id}`)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const createSubscription = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(SUBSCRIPTION, request, {
                params: { include: 'vehicle_info' },
            })
            .then((response) => {
                if (response.status === CREATE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const updateSubscription = (data) => {
    const { token, id, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .put(`${SUBSCRIPTION}/${id}`, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const downloadInvoice = (data) => {
    const { token, record } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(`${DOWNLOAD_INVOICE}/${record.id}`, { responseType: 'blob' })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    var fileName = `${record.payment_date}-invoice.pdf`;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();

                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const downloadContract = (data) => {
    const { token, Id } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(`${DOWNLOAD_CONTRACT}/${Id}`, { responseType: 'blob' })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    var fileName = `contract.pdf`;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getSubscription = (data) => {
    const { token, status } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(SUBSCRIPTION, {
                params: {
                    include: 'billing_history,delivery_info,payment_info,subscriber_info,vehicle_info,profile',
                    status: status,
                    sort: 'desc',
                    sort_dir: 'id',
                },
            })
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const cancelSubscription = (data) => {
    const { token, id } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(`${CANCEL_SUBSCRIPTION}/${id}`)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const getDocuments = (data) => {
    const { token } = data;

    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .get(DOCUMENTS)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .then((error) => {
                reject(error);
            });
    });
};

const createDocument = (data) => {
    const { token, request } = data;

    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(DOCUMENTS, request, {
                headers: {
                    accept: 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === CREATE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const submitNumberOfCarRequire = (data) => {
    const { request } = data;
    request.member_type = 'business';
    return new Promise((resolve, reject) => {
        AxiosClient('')
            .post(ENQUIRY, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const submitContactUs = (data) => {
    const { request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient('')
            .post(CONTACT_US, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const submitFeedback = (data) => {
    const { request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient('')
            .post(FEEDBACK, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const submitEmployeeInfo = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(EMPLOYEE_INFO, request)
            .then((response) => {
                if (response.status === CREATE_SUCCESS || response?.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Connection Failed');
                }
            });
    });
};

const submitIdCard = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(ID_CARD, request, {
                headers: {
                    accept: 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === CREATE_SUCCESS || response.status === RESPONSE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Connection Failed');
                }
            });
    });
};

const submitDeclaration = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(DECLARATION, request, {
                headers: {
                    accept: 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === CREATE_SUCCESS || response.status === RESPONSE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const updateDeclaration = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(`${DECLARATION}`, request, {
                headers: {
                    accept: 'multipart/form-data',
                },
            })
            .then((response) => {
                if (response.status === CREATE_SUCCESS || response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const addLoan = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(LOANS, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const updateLoan = (data) => {
    const { token, id, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .put(`${LOANS}/${id}`, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const deleteLoan = (data) => {
    const { token, id } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .delete(`${LOANS}/${id}`)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const addRelationship = (data) => {
    const { token, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(RELATIONSHIP, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const updateRelationship = (data) => {
    const { token, id, request } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .put(`${RELATIONSHIP}/${id}`, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const deleteRelationship = (data) => {
    const { token, id } = data;
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .delete(`${RELATIONSHIP}/${id}`)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const makeVerify = (data) => {
    const { id, payload } = data;

    return new Promise((resolve, reject) => {
        AxiosClient()
            .get(`${VERIFYING}/${id}?${new URLSearchParams(payload).toString()}`)
            .then((response) => {
                resolve(response);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

const forgetPassword = (data) => {
    const request = {
        email: data.email,
        redirect: PASSWORD_RESET_REDIRECT_LINK,
    };
    return new Promise((resolve, reject) => {
        AxiosClient()
            .post(FORGOT_PASSWORD, request)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Server error!');
                }
            });
    });
};

const submitResetPassword = ({ request }) => {
    return new Promise((resolve, reject) => {
        AxiosClient()
            .post(RESET_PASSWORD, request)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Server error!');
                }
            });
    });
};

const submitChangePassword = ({ request, token }) => {
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(CHANGE_PASSWORD, request)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Server error!');
                }
            });
    });
};

const submitEnquiry = ({ request }) => {
    return new Promise((resolve, reject) => {
        AxiosClient()
            .post(ENQUIRY, request)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Server error!');
                }
            });
    });
};

const payManual = ({ token, subscription_id, request }) => {
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .post(`${MANUAL_PAY}/${subscription_id}`, request)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
            })
            .catch((error) => {
                if (error.response !== undefined) {
                    reject(error.response.data);
                } else {
                    reject('Server error!');
                }
            });
    });
};

const updateLivingExpense = ({ token, id, request }) => {
    return new Promise((resolve, reject) => {
        AxiosClient(token)
            .put(`${UPDATE_LIVING_EXPENSE}/${id}`, request)
            .then((response) => {
                if (response.status === RESPONSE_SUCCESS) {
                    resolve(response);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};

export {
    login,
    signUp,
    getVehicles,
    getVehicleType,
    getVehicleMake,
    searchVehicles,
    getVehiclesDetail,
    calculateVehiclesPrice,
    createProfile,
    updateProfile,
    createLicese,
    getUser,
    createPaymentMethod,
    getPaymentMethod,
    makeDefaultCard,
    deleteCard,
    createSubscription,
    updateSubscription,
    downloadInvoice,
    getSubscription,
    getDocuments,
    createDocument,
    submitNumberOfCarRequire,
    submitContactUs,
    submitFeedback,
    updateLicese,
    submitEmployeeInfo,
    submitIdCard,
    makeVerify,
    forgetPassword,
    submitResetPassword,
    submitEnquiry,
    submitDeclaration,
    updateDeclaration,
    payManual,
    addRelationship,
    updateRelationship,
    deleteRelationship,
    addLoan,
    updateLoan,
    deleteLoan,
    updateLivingExpense,
    downloadContract,
    cancelSubscription,
    submitChangePassword,
};
